import React, { useEffect, useState } from 'react';
import LoginInput from '../components/inputs/LoginInput';
import { useNavigate, useLocation } from "react-router-dom";
import '../App.scss';
import { emailValidation } from '../functions/Validation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelopeCircleCheck } from "@fortawesome/pro-light-svg-icons";
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

export default function ForgotPasswordForm(props: any) {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    props.setCurrentPage(0);
    props.setSidebarVisibility(false);
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState<string | null>(null);
    const [error, setError] = useState<string | null>(null);
    const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData') as string) : null;
    const [resetSuccess, setResetSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        userData && navigate('/YourAccount')
    }, [navigate])

    const forgotPassword = async (e: React.FormEvent) => {
        setLoading(true);
        e.preventDefault();
        setError(null);

        if (!emailValidation(email)) {
            setEmailError("Please enter a valid email")
            setLoading(false);
            return;
        }

        try {
            fetch(`${apiBaseUrl}Admin/ForgotPassword`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "email": email,
                    "clientId": ""
                }),
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.success) {
                        setResetSuccess(true);
                    } else {
                        setError(result.message || 'An Error occured. Please try again');
                        setLoading(false);
                    }
                });
        } catch (err) {
            setError('An error occurred. Please try again later.');
            setLoading(false);
        };
    };

    const updateEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value)
    };

    return (
        <div className="login-form-wrapper">
            {!resetSuccess &&
                <>
                    <form className="login-form" onSubmit={forgotPassword}>
                        <p className="notification-title">Forgot Password</p>
                        <LoginInput
                            label="Email"
                            name="email"
                            type="email"
                            placeholder="Enter your email address"
                            validate={(value: string) => (emailValidation(value) ? null : 'Please enter a valid email')}
                            onChange={updateEmail}
                            submitError={emailError}
                            disabled={loading}
                        />
                        <br />
                        <div className="btn-container">
                            <button className="btn back" onClick={() => navigate('/Login')}>Back: Login</button>
                            {loading && <button disabled className="btn loading" type="submit"> Reset Password <FontAwesomeIcon icon={faSpinner} spinPulse /></button> ||
                                <button className="btn primary" type="submit">Reset Password</button>}
                        </div>
                        {error && <p className="error-message">{error}</p>}
                    </form>
                </>
            }
            {resetSuccess &&
                <div className="formConfirmation">
                    <FontAwesomeIcon className="alert-icon" icon={faEnvelopeCircleCheck} />
                    <p>If you have registered your email, a link will be sent to you. Please check your email to reset your password.
                        <br />If you have not registered your email, please <span onClick={() => navigate('/Register')}>Click here</span></p>
                </div>
            }
        </div>
    );
};

